import React, { useRef } from 'react';

import { inTablet } from '../../hooks/useDimensions';
import { useIsOverflow } from '../../hooks/useIsOverflow';
import TextTooltip from '../TextTooltip';
import { BasicInfoBox } from './VehicleCard';
import {
  InfoBoxIcon,
  InfoBoxValue,
  InfoBoxValueContainer,
  InfoBoxValuesContainer,
  TextWithActionBoxTitle,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';

export interface TextWithActionsBox extends BasicInfoBox {
  value1?: string;
  value2?: string;
  icon1?: JSX.Element;
  icon2?: JSX.Element;
  action1?: any;
  action2?: any;
  iconSize?: string;
}

const VehicleTextWithActionsBox = ({ data }: { data: TextWithActionsBox }) => {
  const value1Ref = useRef();
  const isValue1Overflow = useIsOverflow(value1Ref);

  const value2Ref = useRef();
  const isValue2Overflow = useIsOverflow(value2Ref);

  return (
    <VehicleInfoBoxContainer>
      {data.title && <TextWithActionBoxTitle>{data.title}</TextWithActionBoxTitle>}
      <InfoBoxValuesContainer>
        <InfoBoxValueContainer>
          {data.icon1 && (
            <InfoBoxIcon $clickable onClick={data.action1} $size={data.iconSize}>
              {data.icon1}
            </InfoBoxIcon>
          )}
          {data.value1 && (
            <TextTooltip tooltipText={data.value1} isDisabled={!isValue1Overflow || inTablet()}>
              <InfoBoxValue ref={value1Ref}>{data.value1}</InfoBoxValue>
            </TextTooltip>
          )}
        </InfoBoxValueContainer>
        <InfoBoxValueContainer>
          {data.value2 && (
            <TextTooltip tooltipText={data.value2} isDisabled={!isValue2Overflow || inTablet()}>
              <InfoBoxValue ref={value2Ref}>{data.value2}</InfoBoxValue>
            </TextTooltip>
          )}
          {data.icon2 && (
            <InfoBoxIcon $clickable onClick={data.action2} $size={data.iconSize}>
              {data.icon2}
            </InfoBoxIcon>
          )}
        </InfoBoxValueContainer>
      </InfoBoxValuesContainer>
    </VehicleInfoBoxContainer>
  );
};

export default VehicleTextWithActionsBox;
